import { render, staticRenderFns } from "./CustomersWithManageAccess.vue?vue&type=template&id=fa646580"
import script from "./CustomersWithManageAccess.vue?vue&type=script&lang=js"
export * from "./CustomersWithManageAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports